import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=2f5100bb&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=js&"
export * from "./productList.vue?vue&type=script&lang=js&"
import style0 from "./productList.vue?vue&type=style&index=0&id=2f5100bb&lang=scss&scoped=true&"
import style1 from "./productList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./productList.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5100bb",
  null
  
)

export default component.exports